module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Name":"Titel","Description":"Beschreibung","Color":"Farbe","Allow bookings":"Anmeldungen zulassen","Max. number of bookings per slot":"Maximale Anzahl von Anmeldungen pro Slot","Street":"Straße","Zipcode":"PLZ","City":"Ort","Country":"Land","Category":"Kategorie"}}')
  delete Component.options._Ctor
}
